module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/hannah-duff-3471fe5a981afed8458d32ed35388fb3.jpg";